import './index.css';
import '~/theme/fonts';
import './i18nextConfig';
import React from 'react';
import * as Sentry from '@sentry/react';
import { LocalizedConfigProvider } from '~/components/LocalizedConfigProvider/LocalizedConfigProvider';
import { appComponents, appTheme } from '~/theme/appTheme';
import { applyDwCssVariables } from '~/theme/cssVariables';
import App from './App';
import reportWebVitals from './reportWebVitals';
import dayjs from 'dayjs';
import ErrorBoundary from '~/components/ErrorBoundary/ErrorBoundary';
import { createRoot } from 'react-dom/client';

// Domyślny locale przed pierwszym renderem; dalej zarządza nim LocalizedConfigProvider.
import 'dayjs/locale/pl';
dayjs.locale('pl');

const sentryKey = import.meta.env.VITE_SENTRY_KEY;

if (sentryKey) {
  Sentry.init({
    dsn: sentryKey,
    environment: import.meta.env.VITE_ENV_NAME,
    release: '@akademiasaas/web-app@' + import.meta.env.APP_VERSION,
  });
}

applyDwCssVariables(document.documentElement);

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <LocalizedConfigProvider
        theme={{
          token: appTheme,
          components: appComponents,
        }}
      >
        <App />
      </LocalizedConfigProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
